
const defaults: { length?: number, prefix?: string } = {
    prefix: null,
    length: 5,
};
const source = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function randomString(): string;
export function randomString(prefix?: string): string;
export function randomString(options?: { length?: number, prefix?: string }): string;
export function randomString(prefixOrOptions?: string | { length?: number, prefix?: string }): string {
    let options = typeof prefixOrOptions === 'string'
        ? { prefix: prefixOrOptions }
        : prefixOrOptions;

    options = { ...defaults, ...options };

    let result = options.prefix || '';
    for (let i = 0; i < options.length; i++)
        result += source.charAt(Math.floor(Math.random() * source.length));
    return result;
}